export const CLIENT_ERROR = 'Ошибка клиента';
export const SERVER_ERROR = 'Ошибка сервера';
export const INTERNAL_SERVER_ERROR = 'Внутренняя ошибка сервера';
export const NOT_FOUND_ERROR = 'Not Found';
export const GATEWAY_TIMEOUT = 'Ошибка 504. Удаленный сервер не отвечает';
export const BAD_REQUEST = '400 BAD_REQUEST';

export const CHECKLIST_TEMPLATE_ERROR_DUPLICATE_MESSAGE_PART = 'has duplicate';
export const REQUIREMENTS_TEMPLATE_ERROR_DUPLICATE_MESSAGE_PART = 'has duplicate';
export const LINKED_KNM_ERROR = '400 BAD_REQUEST "Linked knm with erpId = {erpId} already exists."';
export const KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS =
  'KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS';
export const KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS =
  'KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS';
export const CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM =
  'CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM';
export const PLANNED_KNM_CREATED_LATE = 'PLANNED_KNM_CREATED_LATE';
export const KNM_RESULT_FILLED_EARLY = 'KNM_RESULT_FILLED_EARLY';
export const KNM_NOT_AVAILABLE_FOR_CHANGE = 'KNM_NOT_AVAILABLE_FOR_CHANGE';
export const INN_NOT_MATCH_OGRN = 'Данному ИНН не соответствует введенный ОГРН';
export const SNAPSHOT_NOT_FOUND = 'SNAPSHOT_NOT_FOUND';
export const SYSTEM_INOPERABILITY_NOT_ALL_SAVED = 'NOT_ALL_SAVED';
export const DUPLICATE_KEY_REASON_TYPE = 'Duplicate key KnmReasonTypeDTO';
export const KNM_OUT_OF_MEMORY = 'Failed to allocate memory within the configured max blocking time';
export const KNM_OUT_OF_MEMORY_KAFKA =
  'Send failed; nested exception is org.apache.kafka.common.errors.RecordTooLargeException';
export const SEVERAL_REASONS_ARE_FORBIDDEN = 'SEVERAL_REASONS_ARE_FORBIDDEN';
